<template>
    <div>
        <div class="d-flex justify-content-between align-items-center">
            <button class="btn btn-primary m-2" @click.prevent="openCreateModal(null)">Agregar pago</button>
            <div>
                <button class="btn btn-success m-2" @click.prevent="handleCourtesy">Cortesía</button>
                <button class="btn btn-success m-2" @click.prevent="handleRefunded">Reembolsar</button>
                <button class="btn btn-success m-2" @click.prevent="handleCanceled">Cancelar</button>
            </div>
        </div>

        <div class="table-container">
            <table class="minimalist-table">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Cantidad</th>
                        <th class="center-text payment-icon">Método de Pago</th>
                        <th class="center-text">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in filteredItems.data" :key="item.id">
                        <td class="center-text">{{ index + 1 }}</td>
                        <td class="center-text" :class="{ 'refund-row': item.is_refund === true }">{{ item.amount }}
                        </td>
                        <td class="center-text payment-icon">
                            <i :class="getPaymentMethodIcon(item.payment_method_id)"></i>
                        </td>
                        <td class="center-text">
                            <button class="btn btn-link p-0 px-2 pt-3" @click.prevent="openEditModal(item)">
                                <i class="fa-duotone fa-solid fa-pen-to-square"></i>
                            </button>
                            <button
class="btn btn-link p-0 px-2 pt-3"
                                @click.prevent="Delete(item, item.amount, 'del carrito')">
                                <i class="fa-duotone fa-solid fa-trash"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <Pagination
class="mt-3" :total-items="totalItems" :current-page="currentPage" :last-page="lastPage"
            :items-per-page="itemsPerPage" @page-change="changePage" />
        <Modal v-if="openModal" v-model="openModal" :is-edit-mode="isEditMode" @submit-entity="handleEntity">
            <template #default>
                <div class="row">
                    <div class="col-md-6 mb-3">
                        <MenuSelectedFull
v-model="localPaymentMethodId" label="Forma de pago" apiurl="payment-methods"
                            :can-edit-and-add="false" />
                    </div>
                    <div class="col-md-6 mb-3">
                        <label for="amount" class="form-label">Cantidad</label>
                        <input
id="amount" v-model="localAmount" type="number" step="0.01" min="0" class="form-control"
                            @input="localAmount = parseFloat($event.target.value) || 0">
                    </div>
                </div>
            </template>
        </Modal>

        <div v-if="hasRefunds" class="refund-notice">
            <i class="fa-solid fa-circle p-0 px-1 refund-notice-color"></i><span>
                Pagos reembolsados</span>
        </div>

    </div>
</template>

<script setup>
import { ref, getCurrentInstance, computed, defineEmits, watch, onMounted, onUnmounted, defineProps } from 'vue';
import Pagination from '@/components/Pagination.vue';
import { useActions } from '@/composables/useActions';
import Modal from '@/components/Modal.vue';
import MenuSelectedFull from "@/components/MenuSelectedFull.vue";
import Swal from 'sweetalert2';
import api from '@/services/api'

const { proxy } = getCurrentInstance();
const resourceApi = 'sales-payments';

const emit = defineEmits(['get-entity']);

const {
    currentPage,
    itemsPerPage,
    lastPage,
    filteredItems,
    totalItems,
    changePage,
    fetchItems,
    updateShowDeleted,
    addModel,
    editModel,
    showRecord,
    confirmDelete,
    setAdditionalParams,
    message
} = useActions(resourceApi);

const hasRefunds = computed(() => {
    return (
        filteredItems.value?.data &&
        Array.isArray(filteredItems.value.data) &&
        filteredItems.value.data.some(item => item.is_refund === true)
    );
});

const openModal = ref(false);
const isEditMode = ref(false);
const selectedItem = ref(null);
const localPaymentMethodId = ref(1);
const localAmount = ref('');
itemsPerPage.value = 50;

const openEditModal = (item) => {
    isEditMode.value = true;
    selectedItem.value = { ...item };
    localPaymentMethodId.value = item.payment_method_id;
    localAmount.value = item.amount;
    openModal.value = true;
};

const openCreateModal = async () => {
    const sales = await showRecord(props.data, 'sales');
    isEditMode.value = false;
    selectedItem.value = null;
    localPaymentMethodId.value = 1;
    localAmount.value = sales.debts;
    openModal.value = true;
};

const getPaymentMethodIcon = (paymentMethodId) => {
    switch (paymentMethodId) {
        case 1:
            return 'fas fa-money-bill-wave'; // Efectivo
        case 2:
            return 'fas fa-credit-card'; // Tarjeta de crédito
        case 3:
            return 'fas fa-credit-card'; // Tarjeta de débito
        case 4:
            return 'fas fa-university'; // Transferencia bancaria
        case 5:
            return 'fab fa-paypal'; // PayPal
        case 6:
            return 'fas fa-money-check'; // Cheque
        default:
            return 'fas fa-question-circle'; // Desconocido
    }
};

watch([itemsPerPage, currentPage], ([newItemsPerPage, newPage]) => {
    if (newItemsPerPage || newPage) {
        fetchItems(newPage);
    }
});

const refresh = async () => {
    await fetchItems(currentPage.value, true);
};

onMounted(async () => {
    await fetchItems();
    updateShowDeleted(false);
    setAdditionalParams({ sale_id: props.data.id })

    proxy.$eventBus.on('refundApplied', refresh);
});

onUnmounted(() => {
    proxy.$eventBus.off('refundApplied', refresh);
});

const props = defineProps({
    data: Object
});

const getSale = async () => {
    const getSale = await showRecord(props.data, 'sales');
    emit('get-entity', getSale);
};

const Delete = async (item, name, entity) => {
    await confirmDelete(item, name, entity);
    fetchItems();
    getSale();
};

const handleEntity = async () => {
    const saleData = {
        sale_id: props.data.id,
        item_id: selectedItem.value?.item?.id ?? null,
        payment_method_id: localPaymentMethodId.value,
        amount: localAmount.value
    };
    let response;
    if (isEditMode.value) {
        response = await editModel({
            id: selectedItem.value.id,
            ...saleData
        });
    } else {
        response = await addModel(saleData);
    }

    if (response && (response.status === 200 || response.status === 201)) {
        proxy.$notify(message.value, "", "success", "ni ni-like-2 ni-lg");
        openModal.value = false;
        fetchItems();
        getSale();
    }

};

const handleCourtesy = async () => {
    const result = await Swal.fire({
        title: '¿Estás seguro?',
        text: 'No se efectuarán cobros ni adeudos por esta venta.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, aplicar cortesía',
        cancelButtonText: 'Cancelar'
    });

    if (result.isConfirmed) {
        try {
            const response = await api.put(`/sales/${props.data.id}/status/courtesy`);
            if (response.status === 200) {
                Swal.fire({
                    title: 'Cortesía aplicada',
                    text: response.data.message,
                    icon: 'success',
                    confirmButtonText: 'Cerrar'
                });
                fetchItems();
                getSale();
            }
        } catch (error) {
            Swal.fire({
                title: 'Error',
                text: error.response && error.response.status === 422
                    ? error.response.data.error
                    : 'Ocurrió un error al aplicar la cortesía.',
                icon: 'error',
                confirmButtonText: 'Cerrar'
            });
        }
    }
};

const handleRefunded = async () => {
    const result = await Swal.fire({
        title: '¿Estás seguro?',
        text: 'Se rembolsara la venta total.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, aplicar rembolso',
        cancelButtonText: 'Cancelar'
    });

    if (result.isConfirmed) {
        try {
            const response = await api.post(`/sale/${props.data.id}/refund`);
            if (response.status === 200) {
                Swal.fire({
                    title: 'Rembolso aplicado',
                    text: response.data.message,
                    icon: 'success',
                    confirmButtonText: 'Cerrar'
                });
                fetchItems();
                getSale();
            }
        } catch (error) {
            Swal.fire({
                title: 'Error',
                text: error.response && error.response.status === 422
                    ? error.response.data.error
                    : 'Ocurrió un error al aplicar el rembolso.',
                icon: 'error',
                confirmButtonText: 'Cerrar'
            });
        }
    }
};

const handleCanceled = async () => {
    const result = await Swal.fire({
        title: '¿Estás seguro?',
        text: 'La venta será cancelada.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, aplicar cancelación',
        cancelButtonText: 'Cancelar'
    });

    if (result.isConfirmed) {
        try {
            const response = await api.post(`/sale/${props.data.id}/cancel`);
            if (response.status === 200) {
                Swal.fire({
                    title: 'Cancelacion aplicada',
                    text: response.data.message,
                    icon: 'success',
                    confirmButtonText: 'Cerrar'
                });
                fetchItems();
                getSale();
            }
        } catch (error) {
            Swal.fire({
                title: 'Error',
                text: error.response && error.response.status === 422
                    ? error.response.data.error
                    : 'Ocurrió un error al aplicar la cancelación.',
                icon: 'error',
                confirmButtonText: 'Cerrar'
            });
        }
    }
};
</script>

<style scoped>
/* Contenedor de la tabla */
.table-container {
    margin-top: 1rem;
    overflow-x: auto;
}

/* Estilo general de la tabla */
.minimalist-table {
    width: 100%;
    border-collapse: collapse;
    font-family: "Inter", sans-serif;
    font-size: 0.9rem;
}

/* Encabezados de la tabla */
.minimalist-table th {
    background-color: #f8f9fa;
    color: #6c757d;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    padding: 12px;
    text-align: center;
}

/* Filas y celdas */
.minimalist-table td {
    padding: 14px 10px;
    border-bottom: 1px solid #e0e0e0;
    vertical-align: middle;
    /* Asegura alineación vertical correcta */
}

/* Asegurar que la primera columna (Nombre) esté alineada a la izquierda */
.minimalist-table td:first-child {
    text-align: left;
    padding-left: 16px;
}

/* Alternar colores en filas */
.minimalist-table tr:nth-child(even) {
    background-color: #fdfdfd;
}

.minimalist-table tr:hover {
    background-color: #f4f6f8;
}

/* Centrar el texto en las columnas de cantidad, descuento, IVA y total */
.center-text {
    text-align: center;
    font-weight: bold;
    color: #343a40;
}

/* Descripción del producto */
.description {
    font-size: 0.85rem;
    color: #6c757d;
    margin-top: 4px;
}

/* Asegurar que la celda de acciones ocupe la altura total de la fila */
.minimalist-table td:last-child {
    height: 100%;
    vertical-align: middle;
    /* Evita que el contenido se desplace hacia arriba */
    padding: 0;
    /* Elimina padding extra */
}

/* Estilos de los botones */
.btn-group button {
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    padding: 0;
    /* Elimina cualquier padding extra */
    margin: 0;
    /* Elimina cualquier margen extra */
    height: 100%;
    /* Asegura que el botón ocupe toda la celda */
}

/* Estilos de los iconos */
.btn-group i {
    font-size: 1.2rem;
    color: #6c757d;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
}

/* Hover en los iconos */
.icon-edit:hover {
    color: #007bff;
    transform: scale(1.1);
}

.icon-delete:hover {
    color: #dc3545;
    transform: scale(1.1);
}

/* Evitar que el borde inferior de la fila se corte */
.minimalist-table tr:last-child td {
    border-bottom: none;
}

/* Ajuste de anchos de columnas en % */
.minimalist-table th:nth-child(1),
.minimalist-table td:nth-child(1) {
    width: 5%;
    /* Número */
}

.minimalist-table th:nth-child(2),
.minimalist-table td:nth-child(2) {
    width: 10%;
    /* Cantidad */
}

.minimalist-table th:nth-child(3),
.minimalist-table td:nth-child(3) {
    width: 75%;
    /* Método de Pago */
}

.minimalist-table th:nth-child(4),
.minimalist-table td:nth-child(4) {
    width: 10%;
    /* Acciones */
}

/* Evitar que las columnas se deformen */
.minimalist-table th,
.minimalist-table td {
    white-space: nowrap;
    /* Evita que el contenido se divida en varias líneas */
    text-overflow: ellipsis;
    /* Si el contenido es demasiado largo, añade "..." */
    overflow: hidden;
}

/* Ajustar íconos de método de pago */
.payment-icon {
    font-size: 1.0rem;
    /* Hace los íconos más visibles */
    text-align: center;
    color: #233dd2;
}

.refund-row {
    background-color: #ffcccc;
    border-radius: 4px;
}

.refund-notice-color {
    color: #ffcccc;
}

.refund-notice {
    padding-top: 0px;
    border-radius: 5px;
    text-align: left;
    color: #333;
    display: flex;
    align-items: center;
    height: 40px;
    font-size: .80rem;
}
</style>